module.exports = __webpack_public_path__ + "img/book.ccce80e7.svg";